import React from 'react';

/**
 * OptimizedImageWithFallback Component
 * Serve WebP with JPEG fallback for maximum compatibility
 * Includes lazy loading, async decoding, and responsive sizing
 */
export default function OptimizedImageWithFallback({
  src,
  alt,
  srcWebp,
  className = '',
  loading = 'lazy',
  decoding = 'async',
  sizes,
  ...props
}) {
  // Extract base path from src if srcWebp not provided
  const webpSrc = srcWebp || (src?.replace(/\.(jpg|jpeg|png)$/i, '.webp'));

  return (
    <picture>
      {/* WebP format for modern browsers - smaller file size */}
      <source
        srcSet={webpSrc}
        type="image/webp"
        sizes={sizes}
      />
      {/* Fallback JPEG for older browsers */}
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        decoding={decoding}
        sizes={sizes}
        {...props}
      />
    </picture>
  );
}
